/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

export const PanelWrapper = styled.div({
  paddingLeft: token('space.200'),
});

export const BranchLabel = styled.div`
  margin-bottom: ${token('space.100')};
  display: flex;

  > span {
    background: ${token('color.background.input')};
    border-radius: ${borderRadius()}px;
    font-family: ${token('font.family.code')};
    padding: 0 ${token('space.050')};
    ${overflowEllipsis()};
  }
`;
